export default "__VITE_ASSET__CSGNtjvn__"